module.exports = __webpack_public_path__ + "img/1410328.jpg";